export default __webpack_public_path__ + "static/media/img3.9a00ae58.jpg";